import { gql } from '@apollo/client'

export const Query = gql`
  query Accessories(
    $companyId: ID!,
    $filters: AccessoryFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    accessories(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        assetType {
          id
          name
        }
        accessory {
          ... on AssetType {
            id
            name
          }
          ... on RowItem {
            id
            name
          }
        }
        quantity
        optional
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
